import { render, staticRenderFns } from "./CandleList.vue?vue&type=template&id=24f529f1&scoped=true&lang=pug&"
import script from "./CandleList.vue?vue&type=script&lang=ts&"
export * from "./CandleList.vue?vue&type=script&lang=ts&"
import style0 from "./CandleList.vue?vue&type=style&index=0&id=24f529f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f529f1",
  null
  
)

export default component.exports